import React from 'react';
import OrderSelect, { OrderSelectProps } from '../Select';
import { SelectYesNoList } from '../../../../../../contstant';

function SelectEnvironmentallyHazardous({
  options,
  selectProps = {},
  rest = {},
  ...props
}: OrderSelectProps) {
  return (
    <OrderSelect
      options={options || SelectYesNoList}
      selectProps={selectProps}
      rest={rest}
      {...props}
    />
  );
}

export default SelectEnvironmentallyHazardous;
